import { checkedGstinSchema, gstinSchema, phoneSchema } from "@luckymenu/core";

/**
 * Optional customer details on the bill (BL-11, P4-T24): a name, a phone
 * number (also where WhatsApp sends the bill) and a business diner's GSTIN
 * for their input tax credit. Left untouched, the bill takes the order's
 * name and phone; a field emptied leaves it off the bill.
 */
export type CustomerDraft = { name: string; phone: string; gstin: string };

export const EMPTY_CUSTOMER: CustomerDraft = { name: "", phone: "", gstin: "" };

export type CustomerProblem = "tooLong" | "phone" | "gstinFormat" | "gstinCheck";

export type CustomerInput = { name: string | null; phone: string | null; gstin: string | null };

export function customerDraftOf(order: {
	customerName: string | null;
	customerPhone: string | null;
}): CustomerDraft {
	return { ...EMPTY_CUSTOMER, name: order.customerName ?? "", phone: order.customerPhone ?? "" };
}

export function customerFromDraft(
	draft: CustomerDraft,
):
	| { ok: true; customer: CustomerInput }
	| { ok: false; errors: Partial<Record<keyof CustomerDraft, CustomerProblem>> } {
	const errors: Partial<Record<keyof CustomerDraft, CustomerProblem>> = {};
	const name = draft.name.trim();
	if (name.length > 60) errors.name = "tooLong";
	const phone = draft.phone.trim();
	if (phone && !phoneSchema.safeParse(phone).success) errors.phone = "phone";
	let gstin = draft.gstin.trim();
	if (gstin) {
		const format = gstinSchema.safeParse(gstin);
		if (!format.success) errors.gstin = "gstinFormat";
		else if (!checkedGstinSchema.safeParse(gstin).success) errors.gstin = "gstinCheck";
		else gstin = format.data;
	}
	if (Object.keys(errors).length > 0) return { ok: false, errors };
	return { ok: true, customer: { name: name || null, phone: phone || null, gstin: gstin || null } };
}
